import React, { Component } from 'react';
import './ChatContacts.css';
import ChatContact from './ChatContact/ChatContact';
import Contact from './Contact/Contact'
import Spinner from '../../UI/Spinner/Spinner';
import { Tabs, Tab, OverlayTrigger, Tooltip } from 'react-bootstrap';
import DialerContacts from './DialerContacts/DialerContacts'
import DialerBottom from './DialerBottom/DialerBottom'
import DialList from './DialList/DialList'
import NewChatBottom from './NewChatBottom/NewChatBottom'
import * as allCallStatus from '../../../enums/allCallStatus'
import MultiSelectionBar from '../../UI/MultiSelectionBar/multiSelectionBar'
// import { replaceAll } from '../../../util/functions'
import { phonePattern } from '../../../util/constants'
import { withTranslation } from 'react-i18next';
import i18next from "i18next";
import Crm from './CrmModule/Crm'
import { getBaseRecordsByModuleModuleType } from '../../../axios/requests/baseRecordReq'// Base record
import * as settings from '../../../settings'

class ChatContacts extends Component {
    state = {
        tab: 'Chat',
        phoneInput: '',
        time: 0,
        isOn: false,
        start: 0,
        timer: undefined,
        chatContacts: [],
        callContacts: [],
        dialListContacts: []
    }

    processedIds = {
        chat: new Set(),   // phone / e-mail we already queried for chats
        call: new Set(),   // phone numbers we already queried for calls
        dial: new Set()    // phone numbers we already queried for dial list
    };

    componentDidMount() {
        const appAccess = this.props.companyDetails.appAccess
        if (appAccess === 'DIALER') {
            this.handleTabSelected('ContactList')
        }

        /* 🔄 full re-sync every 5 min (updates changed contacts) */
        if (this.props.companyDetails.supportCRM) {
            this.refreshTimer = setInterval(this.refreshAllContacts, 1 * 60_000);
        }

    }

    componentWillUnmount() {
        clearInterval(this.refreshTimer);
        clearInterval(this.state.timer);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.nowCall && this.props.nowCall.ansTime) {
            if (!this.state.isOn) {
                clearInterval(this.state.timer);
                const timer = setInterval(() => this.handleOnTimerTick(), 1000);
                this.setState({
                    isOn: true,
                    timer: timer,
                    time: Date.now() - new Date(this.props.nowCall.ansTime),
                    start: new Date(this.props.nowCall.ansTime)
                });
            }
        } else if (this.state.isOn) {
            clearInterval(this.state.timer);
            this.setState({ time: 0, isOn: false, timer: undefined });
        }
    
        if (!this.props.companyDetails.supportCRM) return;
    
        // conversations 
        const convChanged =
            this.props.conversations.length !== prevProps.conversations.length ||
            this.props.conversations.some((c, i) =>
                c.msgType !== prevProps.conversations[i]?.msgType ||
                c.clientName !== prevProps.conversations[i]?.clientName
            );
    
        if (convChanged) {
            const phones = this.props.conversations
                .filter(c => ['whatsapp', 'sms', 'lead'].includes(c.msgType))
                .map(c => this.normalizePhone(c.clientName));
            const emails = this.props.conversations
                .filter(c => ['mail', 'lead'].includes(c.msgType))
                .map(c => c.clientName);
    
            this.syncWithContacts({ type: 'chat', phones, emails, force: true });
        }
    
        // Calls
        const callsChanged =
            this.props.calls.length !== prevProps.calls.length ||
            this.props.calls.some((c, i) =>
                c.telephoneIntl !== prevProps.calls[i]?.telephoneIntl
            );
    
        if (callsChanged) {
            const phones = this.props.calls.map(c => c.telephoneIntl);
            this.syncWithContacts({ type: 'call', phones });
        }
    
        /* Dial list */
        const dialChanged =
            this.props.dialList.length !== prevProps.dialList.length ||
            this.props.dialList.some((d, i) =>
                d.telephoneIntl !== prevProps.dialList[i]?.telephoneIntl
            );
    
        if (dialChanged) {
            const phones = this.props.dialList.map(d => d.telephoneIntl);
            this.syncWithContacts({ type: 'dial', phones });
        }
    }
    

    /** identifiers already in state *or* already queried */
    getKnownIds = (type) => {
        const keyMap = { chat: 'chatContacts', call: 'callContacts', dial: 'dialListContacts' };
        const fromState = this.state[keyMap[type]].map(c => c.mainPhone || c.email);
        return new Set([...fromState, ...this.processedIds[type]]);
    };

    /** add new contacts if the list really changed */
    mergeIfChanged = (key, newData, force = false) => {
        if (force) {
            this.setState({ [key]: newData });
            return;
        }

        const oldData = this.state[key] || [];

        const oldIds = oldData.map(c => c._id).sort().join(',');
        const newIds = newData.map(c => c._id).sort().join(',');

        if (oldIds !== newIds) {
            this.setState({ [key]: newData });
        }
    };

    fetchContacts = async ({ ids, field, module }) => {
        if (!ids.length) return [];
        const data = await getBaseRecordsByModuleModuleType(
            module, // Contact or Lead
            1,
            settings.LIMIT_ITEMS_PER_PAGE,
            field,
            'desc',
            [{ field, operator: 'equals', value: ids }]
        );

        if (!Array.isArray(data)) {
            console.error(`Unexpected response in fetchContacts for module ${module}`, data);
            return [];
        }

        return data.map(item => ({ ...item, moduleType: module }));
    };

    normalizePhone = (phone) => {
        if (!phone) return '';
        const raw = phone.split('_')[0];
        return raw.startsWith('0') ? raw.replace(/^0/, '+972') : raw;
    }
    /**
     * Core fetcher.
     *  1. first call ⇒ whole list
     *  2. later calls ⇒ only unknown phones/emails
     *  3. refreshAllContacts passes {force:true} so we always re-query
     */
    syncWithContacts = async ({ type, phones = [], emails = [], force = false }) => {
        const known = this.getKnownIds(type);

        const newPhones = force ? phones : phones.filter(p => p && !known.has(p));
        const newEmails = force ? emails : emails.filter(e => e && !known.has(e));

        // remember we tried these numbers/emails (avoids repeating fetch)
        newPhones.forEach(p => this.processedIds[type].add(p));
        newEmails.forEach(e => this.processedIds[type].add(e));

        if (!newPhones.length && !newEmails.length) return;

        const [contactsByPhone, leadsByPhone, contactsByMail, leadsByMail] = await Promise.all([

            this.fetchContacts({ module: 'Contact', ids: newPhones, field: 'mainPhone' }),
            this.fetchContacts({ module: 'Lead', ids: newPhones, field: 'mainPhone' }),
            this.fetchContacts({ module: 'Contact', ids: newEmails, field: 'email' }),
            this.fetchContacts({ module: 'Lead', ids: newEmails, field: 'email' }),
        ]);

        const all = [
            ...contactsByPhone,
            ...leadsByPhone,
            ...contactsByMail,
            ...leadsByMail,
        ];

        // prioritize Contact over Lead
        const byKey = new Map();
        for (const c of all) {
            const phone = c.mainPhone || (Array.isArray(c.fields) && c.fields.find(f => f.name === 'mainPhone')?.value);
            const email = c.email || (Array.isArray(c.fields) && c.fields.find(f => f.name === 'email')?.value);
            const key = phone || email;
            if (!key) continue;

            const existing = byKey.get(key);
            if (!existing || existing.moduleType === 'Lead') {
                byKey.set(key, c);
            }
        }

        const unique = Array.from(byKey.values());

        const keyMap = { chat: 'chatContacts', call: 'callContacts', dial: 'dialListContacts' };
        this.mergeIfChanged(keyMap[type], unique, force);
    };

    /* 🔁 full refresh every 5 min */
    refreshAllContacts = () => {
        /* chats */
        this.syncWithContacts({
            type: 'chat',
            phones: this.props.conversations
                .filter(c => ['whatsapp', 'sms', 'lead'].includes(c.msgType))
                .map(c => this.normalizePhone(c.clientName)),
            emails: this.props.conversations
                .filter(c => ['mail', 'lead'].includes(c.msgType))
                .map(c => c.clientName),
            force: true
        });

        /* calls */
        this.syncWithContacts({
            type: 'call',
            phones: this.props.calls.map(c => c.telephoneIntl),
            force: true
        });

        /* dial list */
        this.syncWithContacts({
            type: 'dial',
            phones: this.props.dialList.map(d => d.telephoneIntl),
            force: true
        });
    };

    // componentWillReceiveProps(nextProps) {
    //     if (nextProps.nowCall && nextProps.nowCall.ansTime) {
    //         // if (nextProps.nowCall.ansTime !== undefined) {
    //         if (!this.state.isOn) {
    //             clearInterval(this.state.timer)
    //             const timer = setInterval(() => this.handleOnTimerTick(), 1000);
    //             this.setState({ isOn: true, timer: timer, time: Date.now() - new Date(nextProps.nowCall.ansTime), start: new Date(nextProps.nowCall.ansTime) })
    //         }
    //         // }
    //     }
    //     else {
    //         clearInterval(this.state.timer)
    //         this.setState({ time: 0, isOn: false, timer: undefined })
    //     }
    // }


    handleOnTimerTick = () => {
        this.setState({ time: Date.now() - this.state.start })
    }

    handleTabSelected = (newTab) => {
        this.props.OnContactTabClicked(newTab);
        this.setState({ tab: newTab });
    }

    handleOnPhoneInput = (event) => {//todo
        // const newValue = replaceAll(event.target.value, /[^\d]/, '')
        // if (newValue.length <= 10) {

        // this.setState({ phoneInput: newValue })
        if (event) {
            event.stopPropagation()
        }
        this.setState({ phoneInput: event.target.value })

        // }
    }

    handleOninputMainPhoneDropDownSelect = (selectedItem) => {//this.props.nowCall.callId , this.props.nowCall.telephone
        // if (selectedItem.length <= 10)
        if (phonePattern.test(selectedItem)) {
            this.setState({ phoneInput: selectedItem.replace(/[^\d]/, '') });
        }
        let callStatus = allCallStatus.DISCONNECTED
        if (this.props.nowCall) {
            if (this.props.nowCall.ansTime) {
                callStatus = this.props.nowCall.ringType === 1 ? allCallStatus.INCOMINGCALL : allCallStatus.OUTGOINGCALL
            }
            else {
                callStatus = this.props.nowCall.ringType === 1 ? allCallStatus.RINGING : allCallStatus.CALLING
            }
        }
        this.props.CallBtClicked(undefined, callStatus, selectedItem)

    }
    render() {
        const appAccess = this.props.companyDetails.appAccess
        const lang = i18next.language
        const { t } = this.props;
        let callStatus = allCallStatus.DISCONNECTED//disconnected,calling,ringing,outGoingCall,inComingCall
        let inCall = this.props.nowCall ? true : false;
        if (this.props.nowCall) {
            if (this.props.nowCall.ansTime) {
                callStatus = this.props.nowCall.ringType === 1 ? allCallStatus.INCOMINGCALL : allCallStatus.OUTGOINGCALL
            }
            else {
                callStatus = this.props.nowCall.ringType === 1 ? allCallStatus.RINGING : allCallStatus.CALLING
            }
        }
        let duration = this.state.time
        let callStatusDisplay = '';
        let callColor = null;
        if (callStatus === allCallStatus.DISCONNECTED) { callStatusDisplay = this.props.t('Not in a call'); callColor = "dialIconGreen" }
        else if (callStatus === allCallStatus.CALLING) { callStatusDisplay = this.props.t('Dialing'); callColor = "dialIconRed" }
        else if (callStatus === allCallStatus.RINGING) { callStatusDisplay = this.props.t('Ringing'); callColor = "dialIconYellow" }
        else if (callStatus === allCallStatus.OUTGOINGCALL) { callStatusDisplay = this.props.t('Outgoing call') + new Date(duration).toISOString().slice(11, 19); callColor = "dialIconRed" }
        else if (callStatus === allCallStatus.INCOMINGCALL) { callStatusDisplay = this.props.t('Incoming call') + new Date(duration).toISOString().slice(11, 19); callColor = "dialIconRed" }

        if (this.props.nowCall?.callerId) {
            callStatusDisplay = (
                <span>
                    {callStatusDisplay}
                    <br />
                    {this.props.nowCall.callerId}
                </span>
            );
        }
        //Show Dialer window?
        let dialerBottom = null;
        if (inCall) {//todo - this.props.nowCall.callId , this.props.nowCall.telephone

            let name = null;
            if (this.props.nowCall?.crmId) name = this.props.nowCall.crmId.name;
            else if (this.props.nowCall?.contactName) name = this.props.nowCall.contactName;
            dialerBottom = <DialerBottom
                inCall={inCall}
                phoneInput={this.props.nowCall?.telephone}
                projectDesc={this.props.nowCallFromDiallist ? this.props.nowCallFromDiallist?.projectDesc : undefined}
                callId={this.props.nowCall?.callId}
                callConfStart={this.props.callConfStart}
                listOfOnlineAgents={this.props.listOfOnlineAgents}
                onPhoneInput={this.handleOnPhoneInput}
                oninputMainPhoneDropDownSelect={this.handleOninputMainPhoneDropDownSelect}
                callStatusDisplay={callStatusDisplay}
                CallBtClicked={(event) => this.props.CallBtClicked(event, callStatus, this.state.phoneInput)}
                callColor={callColor}
                isCallAnswered={callStatus === allCallStatus.OUTGOINGCALL || callStatus === allCallStatus.INCOMINGCALL}
                name={name}
                companyExts={this.props.companyExts}
                OnInCallPostponedClickedAndClosed={(date) => this.props.onAdditionCallDetailsModalToggle(
                    {
                        telephone: this.props.nowCall?.telephone,
                        detailsType: 'REJECT_CALL',
                        onSave: (reason, note, priority) => this.props.OnInCallPostponedClickedAndClosed(date, this.props.nowCall?.telephone, this.props.nowCall?.callId, reason, note, priority)
                    })
                }
                onBmcFinishClicked={() => this.props.onAdditionCallDetailsModalToggle(
                    {
                        telephone: this.props.nowCall?.telephone,
                        detailsType: 'REJECT_CALL',
                        onSave: (reason, note, priority) => this.props.onBmcFinishClicked(reason, note, priority)
                    })}//this.props.onBmcFinishClicked
                onKeyBoardClick={(event, inputName) => this.props.onKeyBoardClick(event, inputName, { callStatus: callStatus, phoneInput: this.state.phoneInput })}
                OnNewConvChannelSelected={this.props.OnNewConvChannelSelected}
                OnNewConvClicked={this.props.OnNewConvClicked}
                onNewConvName={this.props.onNewConvName}
                isOnHold={this.props.nowCall?.isOnHold}
                crm={this.props.nowCall?.crmId}
                onOpenContactCrmWindowClicked={this.props.onOpenContactCrmWindowClicked}
                pbxType={this.props.pbxType}
                rediractions={this.props.nowCall?.rediractions}
            />
        }
        else if ((this.props.nowCallFromDiallist && this.props.nowCallFromDiallist._id)) {
            dialerBottom = <DialerBottom
                inCall={inCall}
                isCallFromDialList={!!this.props.nowCallFromDiallist._id}
                phoneInput={this.props.nowCallFromDiallist.telephone}
                projectDesc={this.props.nowCallFromDiallist.projectDesc}
                onPhoneInput={this.handleOnPhoneInput}
                oninputMainPhoneDropDownSelect={this.handleOninputMainPhoneDropDownSelect}
                callStatusDisplay={callStatusDisplay}
                listOfOnlineAgents={this.props.listOfOnlineAgents}
                CallBtClicked={(event) => this.props.CallBtClicked(event, callStatus, this.state.phoneInput)}
                callColor={callColor}
                OnInCallPostponedClickedAndClosed={(date) => this.props.onAdditionCallDetailsModalToggle(
                    {
                        telephone: this.props.nowCallFromDiallist.telephone,
                        detailsType: 'REJECT_CALL',
                        onSave: (reason, note, priority) => this.props.OnInCallPostponedClickedAndClosed(date, this.props.nowCallFromDiallist.telephone, undefined, reason, note, priority)
                    })}//(date) => this.props.OnInCallPostponedClickedAndClosed(date)
                onBmcFinishClicked={() => this.props.onAdditionCallDetailsModalToggle(
                    {
                        telephone: this.props.nowCallFromDiallist.telephone,
                        detailsType: 'FINISH_CALL',
                        onSave: (reason, note, priority) => this.props.onBmcFinishClicked(reason, note, priority)
                    })}//this.props.onBmcFinishClicked
                isCallAnswered={callStatus === allCallStatus.OUTGOINGCALL || callStatus === allCallStatus.INCOMINGCALL}
                companyExts={this.props.companyExts}
                onExitDialerClicked={this.props.onExitDialerClicked}
                onKeyBoardClick={(event, inputName) => this.props.onKeyBoardClick(event, inputName, { callStatus: callStatus, phoneInput: this.state.phoneInput })}
                crm={this.props.nowCall?.crmId}
                onOpenContactCrmWindowClicked={this.props.onOpenContactCrmWindowClicked}
                OnNewConvChannelSelected={this.props.OnNewConvChannelSelected}
                OnNewConvClicked={this.props.OnNewConvClicked}
                onNewConvName={this.props.onNewConvName}
            />
        }
        else if (this.props.isDialerOpen) {//todo
            dialerBottom = <DialerBottom
                inCall={inCall}
                nowCallFromDiallist={this.props.nowCallFromDiallist}
                phoneInput={this.state.phoneInput}
                onPhoneInput={this.handleOnPhoneInput}
                oninputMainPhoneDropDownSelect={this.handleOninputMainPhoneDropDownSelect}
                callStatusDisplay={callStatusDisplay}
                listOfOnlineAgents={this.props.listOfOnlineAgents}
                CallBtClicked={(event) => this.props.CallBtClicked(event, callStatus, this.state.phoneInput)}
                callColor={callColor}
                isCallAnswered={callStatus === allCallStatus.OUTGOINGCALL || callStatus === allCallStatus.INCOMINGCALL}
                companyExts={this.props.companyExts}
                onExitDialerClicked={this.props.onExitDialerClicked}
                onKeyBoardClick={(event, inputName) => this.props.onKeyBoardClick(event, inputName, { callStatus: callStatus, phoneInput: this.state.phoneInput })}
                crm={this.props.nowCall?.crmId}
                onOpenContactCrmWindowClicked={this.props.onOpenContactCrmWindowClicked}
                OnNewConvChannelSelected={this.props.OnNewConvChannelSelected}
                OnNewConvClicked={this.props.OnNewConvClicked}
                onNewConvName={this.props.onNewConvName}
            />
        }
        let newChatBottom = null
        if (this.props.isNewChatOpen) {//todo
            newChatBottom = <NewChatBottom
                OnNewConvChannelSelected={this.props.OnNewConvChannelSelected}
                newCharOnConvName={this.props.newCharOnConvName}
                NewConvNameTextBoxValue={this.props.NewConvNameTextBoxValue}
                onExitNewChatClicked={this.props.onExitNewChatClicked}
                OnNewConvClicked={this.props.OnNewConvClicked}
                selectedChannelElement={this.props.selectedChannel === 'whatsapp' ? <i className="fab fa-whatsapp fa-lg whatsappIconColorInNewChatSelected" /> : this.props.selectedChannel === 'messenger' ? <i className="fab fa-facebook-messenger messengerIconColor" /> : this.props.selectedChannel === 'sms' ? <i className="fas fa-sms smsIconColor" /> : this.props.selectedChannel === 'instagram' ? <i className="fab fa-instagram instagramIconColor" /> : this.props.selectedChannel === 'mail' ? <i className="fas fa-envelope mailIconColor" /> : this.props.selectedChannel === 'company' ? <i className="fas fa-home companyChat" /> : this.props.selectedChannel === 'facebook' ? <i className="fab fa-facebook facebookIconColor" /> : this.props.selectedChannel === 'ig_media' ? <i className="fab fa-instagram instagramIconColor" /> : null}
                selectedChannel={this.props.selectedChannel}
                // selectedChannel={this.props.selectedChannel==='whatsapp'?['וואטסאפ ',<i class="fab fa-whatsapp"/>]:this.props.selectedChannel==='messenger'?["מסנג'ר ",<i class="fab fa-facebook-messenger"/>]:this.props.selectedChannel==='sms'?['סמס',<i class="fas fa-sms"/>]:this.props.selectedChannel==='mail'?['מייל ',<i class="fas fa-envelope"/>]:null}
                onKeyBoardClick={this.props.onKeyBoardClick}
                facebook_pageAccess={this.props.facebook_pageAccess}
                onNewConvChannelIdSelected={this.props.onNewConvChannelIdSelected}
                NewSelectedChannelObj={this.props.NewSelectedChannelObj}
                appAccess={appAccess}
            />
        }

        //Chat contacts list
        let allConversations = <Spinner />;
        if (!this.props.loadingChat) {
            allConversations = this.props.conversations.map(chat => {
                let latestMsgTime = new Date(chat.latestMsgTime)
                const formatedYear = latestMsgTime.getFullYear()
                const formatedMonth = (latestMsgTime.getMonth() + 1) < 10 ? '0' + (latestMsgTime.getMonth() + 1) : '' + (latestMsgTime.getMonth() + 1)
                const formatedDay = latestMsgTime.getDate() < 10 ? '0' + latestMsgTime.getDate() : '' + latestMsgTime.getDate()
                const formatedHours = latestMsgTime.getHours() < 10 ? '0' + latestMsgTime.getHours() : '' + latestMsgTime.getHours()
                const formatedMinutes = latestMsgTime.getMinutes() < 10 ? '0' + latestMsgTime.getMinutes() : '' + latestMsgTime.getMinutes()
                const formatted_date = formatedDay + '/' + formatedMonth + '/' + formatedYear + ' ' + formatedHours + ':' + formatedMinutes
                // let formatted_date = (latestMsgTime.getMonth() + 1) + "/" + latestMsgTime.getDate() + " " + latestMsgTime.getHours() + ":" + latestMsgTime.getMinutes() //latestMsgTime.getFullYear() + "/" +
                let name = null
                if (chat.crmId && chat.crmId.name) name = chat.crmId.name
                else if (chat.contactId && typeof chat.contactId === 'object') name = chat.contactId.fullName
                else if (chat.displayName) name = chat.displayName
                let loggedAgentSeen = chat.agentSeenCount.find(agentSeen => {
                    return agentSeen.agent === this.props.loggedNowAgent
                })
                let seenCount
                if (!loggedAgentSeen) {
                    seenCount = 0
                }
                else {
                    seenCount = loggedAgentSeen.seen
                }
                return (<ChatContact key={chat._id}
                    nowChatSelected={this.props.nowChatSelected}
                    nowSelectedChannel={this.props.nowSelectedChannel}
                    msgType={chat.msgType}
                    senderName={chat.clientName}
                    name={name}
                    chatSelected={() => this.props.chatSelected(chat.clientName, chat.msgType, 2, chat.crmId, false, chat.channelId)}
                    lastMsg={chat.latestMsg}
                    lastDate={formatted_date}
                    notSeenCount={chat.notSeenCount}
                    seenCount={seenCount}
                    CallBtClicked={(event) => this.props.OnAddToDialListClicked(chat.clientName.replace('+972', '0').split('_')[0])}
                    selectMultipleBtnClicked={this.props.selectMultipleBtnClicked}
                    isChatMultiSelected={chat.isChatMultiSelected}
                    device={this.props.device}
                    isPublic={chat.isPublic}
                    completed={chat.completed}
                    channelName={chat.channelName}
                    OnNewConvChannelSelected={this.props.OnNewConvChannelSelected}
                    OnNewConvClicked={this.props.OnNewConvClicked}
                    onNewConvName={this.props.onNewConvName}
                    groupList={chat.groupList}
                    groupNameFullName={this.props.groupSetting?.groupNameFullName}
                    // ContactsList
                    selectedConv={this.props.selectedConv}
                    onContactListBtnClicked={this.props.onContactListBtnClicked}
                    isContactIdAvailabileMsg={chat.contactId}
                    appAccess={appAccess}
                    companyDetails={this.props.companyDetails}
                    crmSupportChannel={['whatsapp', 'lead', 'sms', 'mail'].includes(chat.msgType) && this.props.companyDetails.supportCRM}
                    // crmContact={['whatsapp', 'lead', 'sms', 'mail'].includes(chat.msgType) && this.state.chatContacts.find((contact) => contact.mainPhone === chat.clientName || contact.email === chat.clientName)}
                    crmContact={['whatsapp', 'lead', 'sms', 'mail'].includes(chat.msgType) &&
                        this.state.chatContacts.find((contact) => {
                            const normalized = this.normalizePhone(chat.clientName);
                            const contactPhone = contact.mainPhone || (Array.isArray(contact.fields) && contact.fields.find(f => f.name === 'mainPhone')?.value);
                            return contactPhone === normalized || contact.email === chat.clientName;
                        })
                    }
                />)

            })
        }
        // let allCalls = <Spinner />;
        let allCalls = null;
        if (this.props.calls[0] !== undefined) {
            allCalls = this.props.calls.map(call => {
                let callTime = new Date(call.startTime)
                const formatedYear = callTime.getFullYear()
                const formatedMonth = (callTime.getMonth() + 1) < 10 ? '0' + (callTime.getMonth() + 1) : '' + (callTime.getMonth() + 1)
                const formatedDay = callTime.getDate() < 10 ? '0' + callTime.getDate() : '' + callTime.getDate()
                const formatedHours = callTime.getHours() < 10 ? '0' + callTime.getHours() : '' + callTime.getHours()
                const formatedMinutes = callTime.getMinutes() < 10 ? '0' + callTime.getMinutes() : '' + callTime.getMinutes()
                const formatted_date = formatedDay + '/' + formatedMonth + '/' + formatedYear + ' ' + formatedHours + ':' + formatedMinutes
                // let formatted_date = (callTime.getMonth() + 1) + "/" + callTime.getDate() + " " + callTime.getHours() + ":" + callTime.getMinutes() //+ ":"  callTime.getSeconds() //callTime.getFullYear() + "-" + 
                let name = null
                if (call.crmId?.name) name = call.crmId.name
                else if (call.contactId && typeof call.contactId === 'object') name = call.contactId.fullName
                else if (call.contactName) name = call.contactName
                return <DialerContacts
                    _id={call._id}
                    key={call._id}
                    callSelected={this.props.callSelected}
                    onCallSelected={() => this.props.onCallSelected(call._id, call.telephone.replace('+972', '0'), call.crmId, call)}
                    clientNum={call.telephone}
                    callType={call.callTypeName}
                    name={name}
                    duration={call.durationSec}
                    callTime={formatted_date}
                    CallBtClicked={(event) => this.props.OnAddToDialListClicked(call.telephone)}
                    selectMultipleBtnClicked={this.props.selectMultipleBtnClicked}
                    isCallMultiSelected={call.isCallMultiSelected}
                    OnNewConvChannelSelected={this.props.OnNewConvChannelSelected}
                    OnNewConvClicked={this.props.OnNewConvClicked}
                    onNewConvName={this.props.onNewConvName}
                    // ContactsList
                    selectedConv={this.props.selectedConv}
                    onContactListBtnClicked={this.props.onContactListBtnClicked}
                    isContactIdAvailabileCalls={call.contactId}
                    appAccess={appAccess}
                    companyDetails={this.props.companyDetails}
                    crmSupportChannel={this.props.companyDetails.supportCRM}
                    // crmContact={this.state.callContacts.find((contact) => contact.mainPhone === call.telephoneIntl)}
                    crmContact={this.state.callContacts.find((contact) => {
                        const mainPhone = contact.mainPhone || (Array.isArray(contact.fields) && contact.fields.find(f => f.name === 'mainPhone')?.value);
                        return mainPhone === call.telephoneIntl;
                    })}
                />

            })
        }

        let dialList = null;
        if (this.props.dialList[0] !== undefined) {//CallStatus,telephone,desc,startTime
            dialList = this.props.dialList.map(dialItem => {
                let callTime = new Date(dialItem.startTime)
                const formatedYear = callTime.getFullYear()
                const formatedMonth = (callTime.getMonth() + 1) < 10 ? '0' + (callTime.getMonth() + 1) : '' + (callTime.getMonth() + 1)
                const formatedDay = callTime.getDate() < 10 ? '0' + callTime.getDate() : '' + callTime.getDate()
                const formatedHours = callTime.getHours() < 10 ? '0' + callTime.getHours() : '' + callTime.getHours()
                const formatedMinutes = callTime.getMinutes() < 10 ? '0' + callTime.getMinutes() : '' + callTime.getMinutes()
                const formatted_date = formatedDay + '/' + formatedMonth + '/' + formatedYear + ' ' + formatedHours + ':' + formatedMinutes
                // let formatted_date = (callTime.getMonth() + 1) + "/" + callTime.getDate() + " " + callTime.getHours() + ":" + callTime.getMinutes() //+ ":" + callTime.getSeconds() //callTime.getFullYear() + "-" +
                let name = null
                if (dialItem.crmId?.name) name = dialItem.crmId.name
                else if (dialItem.contactId && typeof dialItem.contactId === 'object') name = dialItem.contactId.fullName
                return <DialList
                    _id={dialItem._id}
                    key={dialItem._id}
                    dialItemSelected={this.props.dialItemSelected}
                    OnDialItemSelected={() => this.props.OnDialItemSelected(dialItem._id, dialItem.telephone, dialItem.startTime, dialItem.crmId, dialItem)}
                    CallStatus={dialItem.status}
                    telephone={dialItem.telephone}
                    projectDesc={dialItem.projectDesc}
                    desc={dialItem.desc}
                    name={name}
                    startTime={formatted_date}
                    CallBtClicked={() => this.props.dialListUpdate({
                        all: false,
                        data: [{
                            _id: dialItem._id,
                            startTime: new Date(),
                            status: 'waiting'
                        }]
                    })}
                    selectMultipleBtnClicked={this.props.selectMultipleBtnClicked}
                    isDialListMultiSelected={dialItem.isDialItemMultiSelected}
                    OnNewConvChannelSelected={this.props.OnNewConvChannelSelected}
                    OnNewConvClicked={this.props.OnNewConvClicked}
                    onNewConvName={this.props.onNewConvName}
                    // ContactsList
                    selectedConv={this.props.selectedConv}
                    onContactListBtnClicked={this.props.onContactListBtnClicked}
                    isContactIdAvailabileDialList={dialItem.contactId}
                    appAccess={appAccess}
                    companyDetails={this.props.companyDetails}
                    crmSupportChannel={this.props.companyDetails.supportCRM}
                    // crmContact={this.state.dialListContacts.find((contact) => contact.mainPhone === dialItem.telephoneIntl)}
                    crmContact={this.state.dialListContacts.find((contact) => {
                        const mainPhone = contact.mainPhone || (Array.isArray(contact.fields) && contact.fields.find(f => f.name === 'mainPhone')?.value);
                        return mainPhone === dialItem.telephoneIntl;
                    })}
                />
            })
        }

        let contactElements
        if (this.props.contacts) {
            contactElements = this.props.contacts.map(contact => {
                return <Contact
                    contact={contact}
                    onContactSelect={() => this.props.onContactSelect(contact._id)}
                    nowSelectedContact={this.props.nowSelectedContact}

                    CallBtClicked={(event) => this.props.OnAddToDialListClicked(contact.mainPhone.replace('+972', '0').split('_')[0])}
                    OnNewConvChannelSelected={this.props.OnNewConvChannelSelected}
                    OnNewConvClicked={this.props.OnNewConvClicked}
                    onNewConvName={this.props.onNewConvName}
                    onContactListBtnClicked={this.props.onContactListBtnClicked}
                    appAccess={appAccess}
                    device={this.props.device}
                    companyDetails={this.props.companyDetails}
                />
            })
        }

        let isAllChatsSelected = false
        if (this.props.multiSelectCount === this.props.conversations.length) {
            isAllChatsSelected = true
        }

        let isAllCallsSelected = false
        if (this.props.multiSelectCallsCount === this.props.calls.length) {
            isAllCallsSelected = true
        }

        let isAllDialListSelected = false
        if (this.props.multiSelectdialListCount === this.props.dialList.length) {
            isAllDialListSelected = true
        }

        let divStyle_selectContactContainer = 'row contactsSection'
        if ((inCall || this.props.isDialerOpen || (this.props.nowCallFromDiallist && this.props.nowCallFromDiallist._id)) && !this.props.isNewChatOpen) {
            divStyle_selectContactContainer = 'row contactsSection dialerTop'
        }
        else if (this.props.isNewChatOpen && !(inCall || this.props.isDialerOpen || (this.props.nowCallFromDiallist && this.props.nowCallFromDiallist._id))) {
            divStyle_selectContactContainer = 'row contactsSection dialerTop'
        }
        else if (this.props.isNewChatOpen && (inCall || this.props.isDialerOpen || (this.props.nowCallFromDiallist && this.props.nowCallFromDiallist._id))) (
            divStyle_selectContactContainer = 'row contactsSection dialerTopTwoOpen'
        )

        let nowSelectedPage = 0
        let nowSelectedPageDevicedBy = 0
        if (this.state.tab === 'Chat') {
            nowSelectedPage = this.props.selectedChatsPage
            nowSelectedPageDevicedBy = this.props.totalNumOfChatPages
        }
        else if (this.state.tab === 'Dialer') {
            nowSelectedPage = this.props.selectedCallsPage
            nowSelectedPageDevicedBy = this.props.totalCountOfCalls
        }
        else if (this.state.tab === 'DialList') {
            nowSelectedPage = this.props.selectedDialListPage
            nowSelectedPageDevicedBy = this.props.totalCountOfDialList
        }
        else if (this.state.tab === 'ContactList') {
            nowSelectedPage = this.props.selectedContactPage
            nowSelectedPageDevicedBy = this.props.totalCountOfContactPage
        }


        return (
            <div className='row inChatMainRowRight'>
                <div className='col-12'>
                    <div className='row searchSection'>
                        <div className='col-12'>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className={`input-group-text search_btn`} onClick={this.props.SearchSendClicked}><i className="fas fa-search"></i></span>
                                </div>
                                <input type="text" onKeyDown={(e) => this.props.onKeyBoardClick(e, 'searchInput')} onChange={this.props.OnSearchchar} value={this.props.value} placeholder={this.props.t('Searching')} name="" className={`form-control search ${lang === 'en' && 'ltr'}`} />

                            </div>
                        </div>
                    </div>
                    <Tabs
                        transition={false}
                        id="controlled-tab-example"
                        activeKey={this.state.tab}
                        onSelect={this.handleTabSelected}
                        className='cusTabs'
                    >



                        {<Tab tabClassName='chat-tab' eventKey="Chat" title={this.props.t('Msgs')}>
                            <div className={divStyle_selectContactContainer}>
                                <div className='col-12 multipleSelectionBtnsDiv'>
                                    <MultiSelectionBar
                                        isAllSelected={isAllChatsSelected}
                                        selectMultipleBtnClicked={this.props.selectMultipleBtnClicked}
                                        OnSelectAllClicked={this.props.OnSelectAllClicked}
                                        OnSelectMultipleBtnClicked={this.props.OnSelectMultipleBtnClicked}
                                    />
                                </div>
                                <div className='col-12 overFlowContactDiv costContactsCol'>
                                    {allConversations}

                                </div>

                            </div>
                        </Tab>}
                        {this.props.device &&
                            <Tab tabClassName='dialer-tab' eventKey="Dialer" title={this.props.t('Calls')}>
                                <div className={divStyle_selectContactContainer}>
                                    <div className='col-12 multipleSelectionBtnsDiv'>
                                        <MultiSelectionBar
                                            isAllSelected={isAllCallsSelected}
                                            selectMultipleBtnClicked={this.props.selectMultipleBtnClicked}
                                            OnSelectAllClicked={this.props.OnSelectAllCallsClicked}
                                            OnSelectMultipleBtnClicked={this.props.OnSelectMultipleBtnClicked}
                                        />
                                    </div>
                                    <div className='col-12 overFlowContactDiv costContactsCol'>
                                        {allCalls}
                                    </div>
                                </div>
                            </Tab>
                        }
                        {this.props.device &&
                            <Tab tabClassName='dialList-tab' eventKey="DialList" title={this.props.t('Dial list')}>
                                {/* <div className={inCall ? 'row contactsSection dialerTop' : 'row contactsSection'}> */}
                                <div className={divStyle_selectContactContainer}>
                                    <div className='col-12 multipleSelectionBtnsDiv'>
                                        <MultiSelectionBar
                                            isAllSelected={isAllDialListSelected}
                                            selectMultipleBtnClicked={this.props.selectMultipleBtnClicked}
                                            OnSelectAllClicked={this.props.OnSelectAllDialListClicked}
                                            OnSelectMultipleBtnClicked={this.props.OnSelectMultipleBtnClicked}
                                        />
                                    </div>
                                    <div className='col-12 overFlowContactDiv costContactsCol'>
                                        {dialList}
                                    </div>
                                </div>
                            </Tab>}

                        {
                            !this.props.companyDetails.supportCRM &&
                            <Tab tabClassName='contact-list-tab' eventKey="ContactList" title={
                                <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip-left">{t('Contact List')}</Tooltip>}>
                                    <i className="fa-regular fa-address-book contact-list-icon" />
                                </OverlayTrigger>
                            }>
                                <div className={divStyle_selectContactContainer}>
                                    <div className='col-12 multipleSelectionBtnsDiv'>
                                        {/* <MultiSelectionBar
                                            // isAllSelected={isAllDialListSelected}
                                            // selectMultipleBtnClicked={this.props.selectMultipleBtnClicked}
                                            // OnSelectAllClicked={this.props.OnSelectAllDialListClicked}
                                            // OnSelectMultipleBtnClicked={this.props.OnSelectMultipleBtnClicked}
                                        /> */}
                                    </div>
                                    <div className='col-12 contacts-container costContactsCol'>
                                        {contactElements}
                                    </div>
                                </div>
                            </Tab >
                        }
                        {
                            this.props.companyDetails.supportCRM &&//TODO:
                            <Tab tabClassName='contact-list-tab' eventKey="CRM" title={
                                <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip-left">{t('CRM')}</Tooltip>}>
                                    <i className="fa-regular fa-address-book contact-list-icon" />
                                </OverlayTrigger>
                            }>
                                <Crm divStyle_selectContactContainer={divStyle_selectContactContainer} permissionType={this.props.permissionType}/>
                            </Tab >
                        }
                    </Tabs>

                    {dialerBottom}
                    {newChatBottom}
                    <div className='selectPageDiv'>
                        <i onClick={() => this.props.onPageArrowClick('decAll', this.state.tab)} className="fas fa-angle-double-left pageArrowStyle"></i>
                        <i onClick={() => this.props.onPageArrowClick('dec', this.state.tab)} className="fas fa-angle-left pageArrowStyle"></i>
                        <input readOnly="readonly" className='pageNumInput' type='text' value={nowSelectedPage + '/' + nowSelectedPageDevicedBy}></input>
                        <i onClick={() => this.props.onPageArrowClick('inc', this.state.tab)} className="fas fa-angle-right pageArrowStyle"></i>
                        <i onClick={() => this.props.onPageArrowClick('incAll', this.state.tab)} className="fas fa-angle-double-right pageArrowStyle"></i>
                    </div>
                </div>
            </div>
        );
    }
};

export default withTranslation('common')(ChatContacts);
// export default ChatContacts;



// if (this.props.nowCalls[0] !== undefined) {
//     let nowCall = this.props.nowCalls.find(call => (call.ansTime !== undefined))

//     if (nowCall !== undefined) {
//         const nowCallStatus = nowCall.ringType === 1 ? allCallStatus.INCOMINGCALL : allCallStatus.OUTGOINGCALL
//         this.setState({ displayCall: true, phoneInput: nowCall.telephone, callStatus: nowCallStatus })
//     }
//     else {
//         nowCall = this.props.nowCalls[this.props.nowCalls.length - 1]
//         const nowCallStatus = nowCall.ringType === 1 ? allCallStatus.RINGING : allCallStatus.CALLING
//         this.setState({ displayCall: true, phoneInput: nowCall.telephone, callStatus: nowCallStatus })
//     }
// }
// else{
//     this.setState({ displayCall: false, phoneInput: '', callStatus: allCallStatus.DISCONNECTED })
// }